import React from 'react'
import PropTypes from 'prop-types'

export const JUSTIFY_TYPES = [
  'flex-start',
  'flex-end',
  'center',
  'space-between',
  'space-around',
  'space-evenly'
]
export const ALIGN_TYPES = ['center', 'flex-start', 'flex-end']

const Flex = ({
  id,
  alignItems,
  justifyContent,
  column,
  margin,
  width,
  height,
  flex,
  padding,
  wrap,
  children,
  style,
  onClick
}) => {
  const styles = {
    container: {
      display: 'flex'
    }
  }

  if (alignItems) styles.container.alignItems = alignItems
  if (justifyContent) styles.container.justifyContent = justifyContent
  if (column) styles.container.flexDirection = 'column'
  if (padding) styles.container.padding = padding
  if (margin) styles.container.margin = margin
  if (height) styles.container.height = height
  if (flex) styles.container.flex = flex
  if (wrap) styles.container.flexWrap = wrap
  if (width) styles.container.width = width

  return (
    <div id={id} onClick={onClick} style={{ ...styles.container, ...style }}>
      {children}
    </div>
  )
}

Flex.defaultProps = {
  id: undefined,
  alignItems: null,
  justifyContent: null,
  column: false,
  padding: null,
  margin: null,
  height: null,
  flex: null,
  width: null,
  wrap: null,
  style: {},
  onClick: null
}

Flex.propTypes = {
  id: PropTypes.string,
  alignItems: PropTypes.oneOf(ALIGN_TYPES),
  justifyContent: PropTypes.oneOf(JUSTIFY_TYPES),
  column: PropTypes.bool,
  margin: PropTypes.string,
  padding: PropTypes.string,
  height: PropTypes.string,
  flex: PropTypes.string,
  wrap: PropTypes.string,
  width: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ]).isRequired,
  style: PropTypes.shape({}),
  onClick: PropTypes.func
}

export default Flex
